<template>
  <div>
    <h2 class="mobile-page-title">Add/View Project Members</h2>
    <div class="p-actions-wrapper">
      <div class="top-row">
        <md-button class="md-sm md-info add-user" @click="openAddUser">Add User to Project</md-button>
        <div class="grow" />
      </div>
      <div class="addUser" v-if="showAddUser">
        <md-field>
          <label>Email</label>
          <md-input v-model="newUser.email" type="text"></md-input>
        </md-field>
        <md-button class="md-success md-sm" :disabled="clickedOnce" @click="handleAddUser">Add User</md-button>
      </div>
    </div>
    <div  v-for="person in usersAr" :key="person.id">
      <div v-if="!person.new_user" class="gpr-info people">
        <div class="person-info">
          <h6>{{person.name}}</h6>
          <p v-if="person.company">{{person.title}} at {{person.company}}</p>
          <p v-if="person.pending" class="pending">Invitation Pending</p>
          <p class="sm-txt">User added to project at {{person.added_at | formatDate}}</p>
        </div>
        <div class="person-contact" >
          <md-button class="md-primary md-sm" @click="showContactInfo(true, person)">Contact</md-button>
          <md-button class="md-danger md-sm" @click="deleteUser(person)">Remove</md-button>
        </div>
      </div>
      <div v-else  class="gpr-info people">
        <div class="person-image"><!-- image goes here --></div>
        <div class="person-info">
          <h6>{{person.email}}</h6>
          <!-- <p>{{person.title}} at {{person.company}}</p> -->
          <p>Invitation Pending</p>
        </div>
        <div class="person-contact" >
          <md-button class="md-primary md-sm" @click="showContactInfo(false, person)">Contact</md-button>
          <md-button class="md-danger md-sm" @click="deleteUser(person)">Remove</md-button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Swal from "sweetalert2";
  import api from "@/api";
  import moment from 'moment';
  export default {
    props: ['users', 'projectId'],
    data() {
      return {
        showAddUser: false,
        usersAr: [],
        clickedOnce: false,
        newUser: {
          // name: '',
          email: '',
        },
        // people: []
      }
    },
    mounted() {
      this.usersAr = this.users
    },
    methods: {
      showContactInfo(canContact, person) {
        console.log(person);
        if (canContact) {
          var titleString = `${person.name}'s contact info`;
          var textString = `Phone <a href="tel:${person.phone}">${person.phone}</a>, Email <a href="mailto:${person.email}">${person.email}</a>`;
        } else {
          var titleString = "";
          var textString = `${person.email} needs to complete registration before part of project`;
        }

        Swal.fire({
          title: titleString,
          html: textString,
          buttonsStyling: false,
          confirmButtonClass: "md-button md-success"
        });
      },
      openAddUser() {
        this.showAddUser = !this.showAddUser;
      },
      notifyVue(message, color) {
        console.log('here2');
        console.log(this.$notify);
        // var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          timeout: 3000,
          message: message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type: color
        });
      },
      handleAddUser() {
        console.log(this.newUser.email);
        this.clickedOnce = true;
        console.log(this.usersAr)
        var existingUser = this.usersAr.filter((u) => u.email == this.newUser.email)
        if (this.newUser.email && existingUser.length == 0) {
          var data = {
            'email': this.newUser.email,
            'project_id': this.projectId
          }
          api.addNewUserToProject(data).then((response) => {
            console.log(response.data);
            this.showAddUser = false;
            this.showConfirm = true;

            if (response.data.status == '201') {
              //if user is a new user
              this.usersAr.push({
                email: this.newUser.email,
                new_user: true,

              });
              this.notifyVue(`${this.newUser.email} has been added to the project but will need to create their account before joining the project.`, 'success');

            } else if (response.data.status == '205'){
              this.notifyVue('This user has already been added to the project', 'danger');
            } else {
              //if user is an exisiting user in database
              this.usersAr.push(response.data.user);
              if (this.newUser.name) {
                this.notifyVue(`${this.newUser.name} has been added to the project.`, 'success');
              } else {
                this.notifyVue(`${this.newUser.email} has been added to the project.`, 'success');
              }
            }
            this.newUser.email = '';
            this.clickedOnce = false;

          })
        } else {
          this.clickedOnce = false;
          if (existingUser.length > 0){
            this.notifyVue('You cannot add an user twice to a project', 'danger');
          } else {
            this.notifyVue('Must add email to add user', 'danger');
          }
        }
      },
      deleteUser(user) {
        var data = {
          user_id: user.id,
          project_id: this.projectId
        }
        api.deleteUserFromProject(data).then((response) => {
          console.log(response)
          if (response.data.status == 200) {
            var index = this.usersAr.findIndex((u) => u.id == user.id);
            this.usersAr.splice(index, 1);
            this.notifyVue(`${user.email} has been removed from this project`, 'success');
          }
        });
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }
  }
</script>
<style lang="scss">
  .pending {
    font-style: italic;
    font-weight: 400;
  }
</style>

<!-- @click="showContactInfo(person.name, person.phone, person.email)" -->
<!-- <div class="dialog-wrapper add-user">
  <md-dialog :md-active.sync="showDialog">
    <md-dialog-title>Add a User to this Project</md-dialog-title>
    <div class="user-inputs md-layout">
        <md-field class="md-layout-item md-size-100">
          <label>Name</label>
          <md-input v-model="newUser.name" type="text"></md-input>
        </md-field>
        <md-field class="md-layout-item md-size-100">
          <label>Email</label>
          <md-input v-model="newUser.email" type="email"></md-input>
        </md-field>
    </div>
    <div class="button-container">
      <md-button
        @click="handleAddUser"
        class="md-success md-sm mt-4"
        >Add User</md-button
      >
    </div>
  </md-dialog>
</div> -->
